<ion-content>
  <div class="constrained-content">
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <div style="margin: 15px 12px 0 12px">
            <h3>Message Volume</h3>
            <div class="flexed-align-center">
              <div class="pill-tab-container" style="margin-right: 5px">
                <div
                  class="round-pill-tab round-pill-tab-left"
                  [ngClass]="{
                    'round-pill-tab-active': isExternal
                  }"
                  style="font-size: 0.7rem"
                  (click)="isExternal = true; getReports()"
                >
                  Received
                </div>
                <div
                  class="round-pill-tab round-pill-tab-right"
                  [ngClass]="{
                    'round-pill-tab-active': !isExternal
                  }"
                  style="font-size: 0.7rem"
                  (click)="isExternal = false; getReports()"
                >
                  Sent
                </div>
              </div>

              <ion-button
                color="dark"
                fill="clear"
                class="button-dark-border btn-small"
                (click)="showDateOptions()"
                style="margin-right: 5px"
              >
                <ion-icon name="calendar" class="filter-button-icon"></ion-icon>
                <span style="font-weight: 600">{{ dateFilterLabel }}</span>
                <ion-icon name="chevron-down-outline" class="filter-button-caret"></ion-icon>
              </ion-button>

              <ion-button
                color="dark"
                fill="clear"
                class="button-dark-border btn-small"
                (click)="showUserOptions()"
                [hidden]="isExternal"
              >
                <ion-icon name="filter" class="filter-button-icon"></ion-icon>
                <span style="font-weight: 600">{{ userLabel }}</span>
                <ion-icon name="chevron-down-outline" class="filter-button-caret"></ion-icon>
              </ion-button>
            </div>
          </div>
        </ion-col>
        <ion-col size="12" size-md="4">
          <ion-card class="outline-card report-card">
            <span class="report-stat">
              <span class="stat-small">{{ totalCount }}</span>
            </span>
            <div class="report-title">Total messages {{ isExternal ? 'received' : 'sent' }}</div>
          </ion-card>
        </ion-col>
        <ion-col size="12">
          <ion-card class="report-card outline-card">
            <div class="flex-space-between">
              <h4 class="card-title">Average message volume by day of week</h4>
              <ion-button fill="clear" class="btn-small" (click)="downloadDowData()">
                <ion-icon name="cloud-download"></ion-icon>
              </ion-button>
            </div>
            <div class="padded" style="height: 200px">
              <ion-skeleton-text [animated]="true" *ngIf="isLoading"></ion-skeleton-text>
              <canvas
                *ngIf="!isLoading"
                baseChart
                [datasets]="messagesByDowDatasets"
                [labels]="dayOfWeekLabels"
                [options]="messagesByDowOptions"
                type="bar"
              ></canvas>
            </div>
          </ion-card>
        </ion-col>
        <ion-col size="12">
          <ion-card class="report-card outline-card">
            <div class="flex-space-between">
              <h4 class="card-title">Average message volume by day of week and hour</h4>
              <ion-button fill="clear" class="btn-small" (click)="downloadPeriodData()">
                <ion-icon name="cloud-download"></ion-icon>
              </ion-button>
            </div>
            <div class="padded" style="height: 420px">
              <ion-skeleton-text [animated]="true" *ngIf="isLoading"></ion-skeleton-text>
              <canvas
                *ngIf="!isLoading"
                baseChart
                [datasets]="messagesByPeriodDatasets"
                [options]="messagesByPeriodOptions"
                type="bubble"
              ></canvas>
            </div>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
